import React from "react";
import * as Notifications from "src/core/notifications";
import Modal from "../../common/components/modules/modal/Modal";
import {ModalBackButton} from "../../common/components/modules/modal/modalComponents";
import useRouter from "../../common/hooks/useRouter";
import useAuthentication from "src/core/authentication/hooks/useAuthentication";
import get from "lodash/get";
import BillingAddressForm from "./BillingAddressForm";
import useUserProfile from "src/core/authentication/hooks/useUserProfile";

function BillingAddressModal({isOpen, closeModal}) {
  const [, authApi] = useAuthentication();
  const [profile] = useUserProfile();
  const router = useRouter();
  const {query} = router;

  function _onSuccess({address, useDeliveryAddress}) {
    authApi.isLoggedIn() && authApi.updateUser({billing: {address, useDeliveryAddress}});
    onBack();
  }
  function onFailure(msg = "Sorry, we don't deliver to that location.") {
    Notifications.error(msg);
  }
  function onBack() {
    router.safeBack();
  }

  return (
    <Modal isOpen={isOpen} closeModalOverride={closeModal}>
      <ModalBackButton onClick={onBack} />
      <BillingAddressForm
        loading={profile.loading}
        onSuccess={_onSuccess}
        onFailure={onFailure}
        errorMessage={get(query, "state.message")} //might not work
      />
    </Modal>
  );
}

export default BillingAddressModal;
